export default "__VITE_ASSET__b62bd698__"